import { useState } from "react";
import { AccordionItem } from "../UI/Accordion";
import Button from "../UI/Button";
import MailTemplateForm from "./MailTemplateForm";
import Text from "../UI/Text";
import type { MailTemplateMeta } from "../../models/mailTemplate";
import styles from "./MailTemplate.module.css";
import { IconPencil } from "@tabler/icons-react";

interface MailTemplateProps {
  meta: MailTemplateMeta;
  profileBailleurId?: number;
  isProfile?: boolean;
}

export default function MailTemplate({
  meta,
  profileBailleurId,
  isProfile,
}: MailTemplateProps) {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <>
      <MailTemplateForm
        meta={meta}
        profileBailleurId={profileBailleurId}
        isProfile={isProfile}
        open={formOpen}
        onOpenChange={setFormOpen}
      />
      <AccordionItem value={meta.static_id} title={meta.title}>
        <div className={styles.content}>
          <Text>{meta.description}</Text>
          <Button
            variant="secondary"
            onClick={() => setFormOpen(true)}
            icon={IconPencil}
            className={styles.action}
          >
            Modifier
          </Button>
        </div>
      </AccordionItem>
    </>
  );
}
